// extracted by mini-css-extract-plugin
export default {"ingredient_type_block":"ingredients-category_ingredient_type_block__4BSlc"};